import Blog, { BlogType } from "./Blog";

export { Blog, BlogType };

export default Blog;
